"use client"

import {useEffect, useState} from "react";
import {Centrifuge} from "centrifuge";
// import { useParams } from "next/navigation";

const useCentrifuge = ({chatId,bearerToken, userId, onSuccess,channelNameDs= false}) => {
    //support_chat_id=9#user_id=6
    // const params = useParams();
    const [centrifuge, setCentrifuge] = useState(null);
    const [subscription, setSubscription] = useState(null);
    const [listOfSubscribe, setListOfSubscribe] = useState([]);

    function getToken(url, ctx) {
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + bearerToken
                }),
            })
                .then(res => {
                    if (!res.ok) {
                        throw new Error(`Unexpected status code ${res.status}`);
                    }
                    return res.json();
                })
                .then(data => {
                    resolve(data.token);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }


    useEffect(() => {
        if (bearerToken && centrifuge === null) {
            setCentrifuge(new Centrifuge("wss://" + process.env.NEXT_PUBLIC_CENTRIFUGE_URL  + "/connection/websocket", {
                debug: true,
                getToken: function (ctx) {
                    return getToken(process.env.NEXT_PUBLIC_URL_BACKEND+'/api/chat/get-token', ctx);
                }
            }));
        }
    }, [])

    useEffect(()=>{
        if(centrifuge !== null){
            centrifuge.on('connecting', function (ctx) {
                console.log(`connecting: ${ctx.code}, ${ctx.reason}`);
            }).on('connected', function (ctx) {
                console.log(`connected over ${ctx.transport}`);
            }).on('disconnected', function (ctx) {
                console.log(`disconnected: ${ctx.code}, ${ctx.reason}`);
            }).connect();
        }
    },[centrifuge])

    useEffect(()=>{

        if(subscription !== null){

            subscription.unsubscribe();
            subscription.removeAllListeners();

        }

        if(centrifuge !== null){
            const channelName = channelNameDs?channelNameDs: "chat_id=" + chatId + "#user_id=" + userId;

            const sub = listOfSubscribe.filter(item=>item.channel === channelName);

            if(!sub.length){
                const newSubscription = centrifuge.newSubscription(channelName)
                setSubscription(newSubscription );
                setListOfSubscribe((prev)=>[...prev, newSubscription]);
            } else{
                sub[0].subscribe();
                setSubscription(sub[0]);
            }

            console.log("chat_id=" + chatId + "#user_id=" + userId);

        }
    },[chatId,centrifuge]);

    useEffect(()=>{
        if(subscription!==null){
            subscription.on('publication', function (ctx) {
                onSuccess(ctx.data);
            }).on('subscribing', function (ctx) {
                console.log(`subscribing: ${ctx.code}, ${ctx.reason}`);
            }).on('subscribed', function (ctx) {
                console.log('subscribed', ctx);
            }).on('unsubscribed', function (ctx) {
                console.log(`unsubscribed: ${ctx.code}, ${ctx.reason}`);
            }).subscribe();
        }

    },[subscription])

    return null;
};

export default useCentrifuge;
